// extracted by mini-css-extract-plugin
export default {"message":"PaymentAlerts_message__0jd7E","paymentAlerts":"PaymentAlerts_paymentAlerts__Dr7Sf"};